<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection title="Penilaian KPI">
          <!-- <div class="text-right">
            <ArgonButton :to="{ name: 'Create Assignment KPI Pegawai' }" isRouteLink>+ Tambah Assignment KPI</ArgonButton>
          </div> -->
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <!-- <CardComponent :useHeader="true"> -->
        <CardComponent use-header>
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <!-- <FormGroup class="m-0 w-40">
                    <select @change="getData()" class="form-control" v-model="params.limit">
                      <option v-for="(item, index) in limit_list" :key="index" :value="item">{{ item }}</option>
                    </select>
                  </FormGroup> -->

                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                      placeholder="Cari NIP/nama pegawai..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="list_periode"
                      option-value="id"
                      option-text="name"
                      placehodler="Pilih Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unit"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.jabatan"
                      :list="list_jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Jabatan"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.status"
                      :list="status_list.map((item) => {return {value:item, text:status_label?.[item]}})"
                      option-value="value"
                      option-text="text"
                      placeholder="Semua Status"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>


          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                  
                  <th
                    v-for="item in thead"
                    :key="item"
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {{ item }}
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!data || data?.length === 0">
                  <td :colspan="thead.length+1" class="text-center p-4">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item?.nip || '-' }}</td>
                  <td class="font-weight-bolder">{{ item?.name || '-' }}</td>
                  <td><div class="column-truncate">{{ item?.unitkerja || '-' }}</div></td>
                  <td><div class="column-truncate">{{ item?.jabatan || '-' }}</div></td>
                  <td>
                    <argon-badge
                      v-if="item?.submission_status"
                      :color="status?.[item?.submission_status] || 'secondary'"
                      class="text-capitalize"
                    >
                      <!-- {{ item?.submission_status?.replaceAll('_', ' ') }} -->
                      {{ status_label?.[item?.submission_status] || item?.submission_status }}
                    </argon-badge>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <ThreeDotsMenu>
                      <!-- <router-link :to="{ name: 'Ubah Assignemnt KPI Pegawai', params: { id: item?.id ?? 0 } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Edit assignment">Edit</router-link>
                      <button @click.prevent="deleteData(item.id)"
                        class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                        data-original-title="Delete user">Hapus</button> -->

                      <router-link :to="{ name: 'Penilaian KPI Detail', params: {
                        employee_id: item.employee_id,
                        realization_id: item.realization_id,
                        submission_status: item.submission_status,
                        periode_id: item.periode_id
                      } }"
                      >
                        Detail
                      </router-link>
                    </ThreeDotsMenu>
                  </td>
                </tr>
              </tbody>
              
            </table>
          </div>

          <!-- <div v-if="data.length > 0" class="d-flex flex-row flex-wrap gap-2 justify-content-center align-items-center">
            <button type="button" @click="params.page = params.page - 1; getData(params.page);"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-left" /></button>
            <p>{{ metaData?.current_page ?? "&infin;" }} / {{ metaData?.total_page ?? "&infin;" }}</p>
            <button type="button" @click="params.page = params.page + 1; getData(params.page);"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-right" /></button>
          </div> -->

          <ArgonPagination
            :page="params.page"
            :total_page="metaData?.total_page"
            :current_page="metaData?.current_page"
            @changepage="getData"
            @changelimit="changeLimit"
          />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
// import ArgonButton from '@/components/ArgonButton.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';

// import KpiUsulanApi from '@/repository/api/KpiUsulanApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import PenilaianKpiApi from '@/repository/api/PenilaianKpiApi';
import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    // ArgonButton,
    ArgonPagination,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      metaData: {},
      unitkerja: [],
      list_jabatan: [],
      limit_list: [2, 10, 25, 50, 100],
      list_periode: [],
      params: {
        status: "",
        unit: "",
        jabatan: "",
        keyword: "",
        limit: 10,
        page: 1,
        periode_id: '',
        list_mode: '',
        leader_id: '',
      },
      // timer: null,
      thead: [
        'NIP',
        'Nama',
        'Unit Kerja',
        'Jabatan',
        'Status',
        '', // actions
      ],
      status_list: [
        'submission',
        'accept_direct_supervisor',
        'reject_direct_supervisor',
        'accept_immediate_supervisor',
        'reject_immediate_supervisor',
      ],
      status: {
        submission: 'primary',
        accept_direct_supervisor: 'info',
        reject_direct_supervisor: 'danger',
        accept_immediate_supervisor: 'success',
        reject_immediate_supervisor: 'danger',
      },
      status_label: {
        submission: 'Diajukan',
        resubmission: 'Diajukan Ulang',
        reject_direct_supervisor: 'Ditolak Direct SPV',
        accept_direct_supervisor: 'Diterima Direct SPV',
        revisi_direct_supervisor: 'Revisi Direct SPV',
        reject_immediate_supervisor: 'Ditolak Immediate SPV',
        accept_immediate_supervisor: 'Diterima Immediate SPV',
      },
      employee: null,
    };
  },
  watch: {
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.status': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.unit': function(newValue) {
    // params.unit: (newValue) => {
      if (newValue) {
        this.params.jabatan = '';
        this.getJabatan();
      } else {
        this.list_jabatan = [];
      }
      this.getData();
    },
    'params.jabatan': {
      handler: async function () {
        await this.getData();
      }
    }
  },
  methods: {
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.unitkerja = response?.data;
        }).catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({
        unitkerja_id: this.params.unit,
        page: 'all',
      })
        .then((response) => {
          this.list_jabatan = response?.data;
        }).catch(() => {
          this.list_jabatan = [];
        })
      this.$store.state.loading = false;
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async searchKeyword() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650)
    },
    changeLimit(limit) {
      this.params.limit = limit;
      this.getData();
    },
    async getData(page=1) {
      this.$store.state.loading = true;
      this.data = [];
      this.metaData = {};
      this.params.page = page;

      await PenilaianKpiApi.getList(this.params)
      // await PenilaianKpiApi.getList({
      //   limit: this.params.limit,
      //   page: this.params.page,
      //   periode_id: this.params.periode_id,
      //   list_mode: this.params.list_mode,
      //   leader_id: this.params.leader_id,
      // })
        .then((resp) => {
          // console.log('resp', resp)
          this.data = resp?.data;

          this.metaData = {
            status: resp?.status ?? null,
            message: resp?.message ?? null,
            total_item: resp?.total_item ?? null,
            per_page: resp?.per_page ?? null,
            total_page: resp?.total_page ?? null,
            current_page: resp?.current_page ?? null,
          };
        })
        .catch((err) => {
          console.log(err)
        })
      this.$store.state.loading = false;
    },

    async getDataAll() {
      // await KpiUsulanApi.getbyparam(this.params).then((response) => {
      //   this.data = response.data;
      // }).catch(() => {
      //   this.data = [];
      // })
    },
    // async deleteData(id) {
    //   this.$swal({
    //     icon: "warning",
    //     title: "Apakah anda yakin ingin menghapus?",
    //     showCancelButton: true,
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       await KpiUsulanApi.delete(id).then(() => {
    //         this.getData();
    //         this.$swal({
    //           icon: "success",
    //           title: "Berhasil"
    //         });
    //       }).catch((error) => {
    //         this.$swal({
    //           icon: "error",
    //           title: "Error",
    //           text: error.response.data.message,
    //         });
    //       });
    //     }
    //   })
    // }
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    // this.employee = this.$store.state?.sessionUser?.employee || null;
    // console.log(this.employee?.jabatan?.code)
    console.log(this.$store.state?.sessionUser)
    if (this.$store.state?.sessionUser?.groups?.[0]?.label === 'direct_supervisor' || this.$store.state?.sessionUser?.groups?.[0]?.label === 'immediate_supervisor') {
      this.params.list_mode = this.$store.state?.sessionUser?.groups?.[0]?.label;
      this.params.leader_id = this.$store.state?.sessionUser?.employee?.id;
    }
    await this.getUnitKerja();
    await this.getKpiPeriode();
    await this.getData();
    this.$store.state.loading = false;
  },
};
</script>
